var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 30,
    height: 30,
    rx: 15,
    transform: "rotate(180 30 30)",
    fill: "#5A34E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.1925 20.1915C19.8372 20.5468 19.2612 20.5468 18.9059 20.1915L15.0003 16.2859L11.0946 20.1915C10.7393 20.5468 10.1633 20.5468 9.80799 20.1915C9.45269 19.8362 9.45269 19.2602 9.80799 18.9049L13.7136 14.9993L9.80799 11.0936C9.45269 10.7384 9.45269 10.1623 9.80799 9.80701C10.1633 9.45172 10.7393 9.45172 11.0946 9.80701L15.0003 13.7126L18.9059 9.80701C19.2612 9.45172 19.8372 9.45172 20.1925 9.80701C20.5478 10.1623 20.5478 10.7384 20.1925 11.0936L16.2869 14.9993L20.1925 18.9049C20.5478 19.2602 20.5478 19.8362 20.1925 20.1915Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.14a5f4afa849357302b3cff77f1b2cfe.svg";
export { ForwardRef as ReactComponent };